import React, { useContext } from 'react';
import { Button } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { ActivityCreateExtras } from '@totem/components/ticketing/types';

type Props = {
  extras?: ActivityCreateExtras;
};

const ButtonCreateActivity = ({ extras }: Props) => {
  const { onAction } = useContext(TicketContext);
  return (
    <Button
      type="primary"
      onClick={() =>
        onAction(
          'show-activity-create',
          extras !== null ? JSON.stringify(extras) : '',
        )
      }
    >
      Add Activity
    </Button>
  );
};

export default ButtonCreateActivity;
